import { Component, OnDestroy, OnInit,ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { Distributor } from '../../shared/models/Distributor';
import { FilterObject } from '../../shared/models/FilterObject';
import { OrderDetail } from '../../shared/models/OrderDetail';
import { OrderHistory } from '../../shared/models/OrderHistory';
import { PagingResults } from '../../shared/models/PagingResult';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';
import { MatMenu } from '@angular/material/menu';

@Component({
  selector: 'app-order-status',
  templateUrl: './order-status.component.html',
  styleUrls: ['./order-status.component.css']
})
export class OrderStatusComponent implements OnInit, OnDestroy {
  @ViewChild(MatMenu) matFilterMenu: MatMenu;
  readonly Page: string = "OrderStatus";
  OrderList: OrderHistory[];
  DistList: Distributor[];
  DistSubscription: Subscription;
  CurrentDist: string;
  OrderSortValue: string;
  HideDist: boolean;
  CurrOrderDetails: OrderDetail[];
  CurUser: User;
  FilterList: FilterObject[];
  CustFilter: FilterObject;

  OrderNumber_Filter: FilterObject;
  PreFilterOrderNumber: string;
  OrderDateMin_Filter: FilterObject;
  OrderDateMax_Filter: FilterObject;
  PONumber_Filter: FilterObject;
  JobNumber_Filter: FilterObject;
  ShipTo_Filter: FilterObject;
  SerialNumber_Filter: FilterObject;
  PartNumber_Filter: FilterObject;
  Max_EndDate: Date;
  PageIndex: number;
  PageSize: number;
  ItemCount: number;
  CurrentOpenDialog: MatDialogRef<ModalComponent, any>;
  readonly PageSizeOptions: number[] = [5, 10, 20, 50];
  hideLoadingModal: boolean;

  constructor(private global: GlobalService, private http: HttpService, private router: Router, public matDialog: MatDialog) {
    debugger;
    //look for state object to pre select distributor and filter(sort)
    var curNavigation = this.router.getCurrentNavigation();
    if (curNavigation) {
      var stateObject = curNavigation.extras.state;
      if (stateObject) {
        if (stateObject.sortValue) {
          this.OrderSortValue = stateObject.sortValue;
        }
        if (stateObject.distributor) {
          this.CurrentDist = stateObject.distributor;
        }
        if (stateObject.orderNumber) {
          this.PreFilterOrderNumber = stateObject.orderNumber;
        }
      }
    }
  }


  ngOnInit(): void {
    this.hideLoadingModal = true;
    this.Max_EndDate = new Date();
    this.PageIndex = 0;
    this.PageSize = 20;
    
    this.CurUser = new User();
    this.CustFilter = new FilterObject();
    this.OrderNumber_Filter = new FilterObject();
    this.OrderNumber_Filter.Key = "ordernumber";
    this.OrderDateMax_Filter = new FilterObject();
    this.OrderDateMax_Filter.Key = "orderdate";
    this.OrderDateMax_Filter.Operand = "lt";
    this.OrderDateMax_Filter.Value = "";
    this.OrderDateMin_Filter = new FilterObject();
    this.OrderDateMin_Filter.Key = "orderdate";
    this.OrderDateMin_Filter.Operand = "gt";
    this.OrderDateMin_Filter.Value = "";
    this.PONumber_Filter = new FilterObject();
    this.PONumber_Filter.Key = "ponumber";
    this.PONumber_Filter.Value = "";
    this.ShipTo_Filter = new FilterObject();
    this.ShipTo_Filter.Key = "shiptoname";
    this.ShipTo_Filter.Value = "";
    this.JobNumber_Filter = new FilterObject();
    this.JobNumber_Filter.Key = "jobnumber";
    this.JobNumber_Filter.Value = "";
    this.PartNumber_Filter = new FilterObject();
    this.PartNumber_Filter.Key = "partnumber";
    this.PartNumber_Filter.Value = "";
    this.SerialNumber_Filter = new FilterObject();
    this.SerialNumber_Filter.Key = "serialnumber";
    this.SerialNumber_Filter.Value = "";
    this.OrderSortValue = this.OrderSortValue ?? "orderdate";

    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
      
      
      if (!this.CurUser || this.CurUser == null) {
        this.router.navigate(['/']);
      }

      if (this.CurUser.IsTolomaticUser) {
        this.HideDist = false;
      }
      else {
        this.HideDist = true;
      }
      this.FilterList = [];
      
      if (this.PreFilterOrderNumber) {
        this.OrderNumber_Filter.Value = this.PreFilterOrderNumber;
      }
      else {
        this.OrderNumber_Filter.Value = "";
      }
      this.FilterList.push(this.OrderNumber_Filter);
      
      //this.OrderDateMax_Filter.Value = this.Max_EndDate.toISOString();
      this.FilterList.push(this.OrderDateMax_Filter);      
      this.FilterList.push(this.OrderDateMin_Filter);      
      this.FilterList.push(this.PONumber_Filter);      
      this.FilterList.push(this.ShipTo_Filter);      
      this.FilterList.push(this.JobNumber_Filter);     
      this.FilterList.push(this.PartNumber_Filter);      
      this.FilterList.push(this.SerialNumber_Filter);

      this.CustFilter.Key = "customer";

      this.http.GetDistributors().then(x => {
        if (x.StatusCode == "200") {
          this.DistList = x.Content;
          var index = 1;
          this.DistList.forEach(dist => {
            dist.SortIndex = index;
            index++;
          });
          var allDist = new Distributor();
          allDist.Company = "All Distributors";
          allDist.CompanyId = "00000000-0000-0000-0000-000000000000";
          allDist.SortIndex = 0;
          this.DistList.push(allDist);
          this.DistList.sort((a, b) => {
            if (a.SortIndex > b.SortIndex) {
              return 1;
            }
            else {
              return -1;
            }
          });

          this.global.getCurrentDist().then(dist => {
            
            if (dist) {
              if (!this.CurUser.IsTolomaticUser && this.CurUser.DistributorId == dist.CompanyId) {
                this.CurrentDist = dist.CompanyId;
              }
              else if (this.CurUser.IsTolomaticUser) {
                this.CurrentDist = dist.CompanyId;
              }
              else {
                this.CurrentDist = this.CurUser.DistributorId;
              }
            }
            else {
              if (!this.CurUser.IsTolomaticUser && this.CurUser.DistributorId != "") {
                this.CurrentDist = this.CurUser.DistributorId;
              } else {
                this.CurrentDist = this.DistList[0].CompanyId;
              }
            }

            this.CustFilter.Value = this.CurrentDist;
            //this.FilterList = [];
            this.FilterList.push(this.CustFilter);
            this.LoadOrders();
            //this.ResetFilters();
            this.http.PostUserActivity(this.CurUser.UserId.toString(), "Order Status", "Load", "", this.CurUser.IsTolomaticUser ? dist.CompanyId : this.CurUser.DistributorId);
          });
          
        }
      });
      var initialLoad = true;
      this.DistSubscription = this.global.CurrentDist.subscribe(dist => {
        debugger;
        if (dist && dist.CompanyId != this.CurrentDist && !initialLoad) {
          this.CurrentDist = dist.CompanyId;
          this.CustFilter.Value = this.CurrentDist;
          this.LoadOrders();
        }
        initialLoad = false;
      });

    });
    

  }

  ngOnDestroy() {
    if (this.DistSubscription) {
      this.DistSubscription.unsubscribe();
    }
  }

  ResetFilters() {
    
    this.OrderDateMax_Filter.Value = "";
    this.OrderDateMin_Filter.Value = "";
    this.OrderNumber_Filter.Value = "";
    this.PONumber_Filter.Value = "";
    this.ShipTo_Filter.Value = "";
    //this.matFilterMenu.close.emit();
    this.LoadOrders();
  }

  LoadOrders() {
    this.hideLoadingModal = false;
    this.http.GetOrders(this.FilterList, this.CurUser.UserId.toString(), this.PageIndex, this.PageSize, this.OrderSortValue).then(x => {
      if (x.StatusCode == "200") {
        var results = <PagingResults>x.Content;
        this.OrderList = results.Items;
        this.ItemCount = results.ItemCount;
        this.OrderList.forEach(x => {
          x.ShortShipTo = x.ShipToName;
          if (x.ShortShipTo.length > 20) {
            x.ShortShipTo = x.ShortShipTo.substring(0, 20) + "...";
          }
        });
      }
      this.hideLoadingModal = true;
    });
  }


  LoadDetails(custOrder: OrderHistory) {
    if (!custOrder.OrderLines) {
      this.hideLoadingModal = false;
      this.http.GetOrderDetails(custOrder.OrderNumber, this.CurUser.UserId.toString()).then(x => {
        if (x.StatusCode == "200") {
          custOrder.OrderLines = x.Content;
          custOrder.OrderLines.forEach(x => {
            x.ShortDesc = x.Description;
            if (x.ShortDesc.length > 20) {
              x.ShortDesc = x.ShortDesc.substring(0, 17) + "...";
            }
          });
        }
        this.hideLoadingModal = true;
      });
    }
  }


  Dist_Change(event: any) {
    //this.CurrentDist = event.value;
    //this.CustFilter.Value = this.CurrentDist;
    if (event.value != "00000000-0000-0000-0000-000000000000") {
      var newDist = this.DistList.filter(x => x.CompanyId == event.value)[0];
      this.global.setCurrentDist(newDist);
    }
    else {
      this.CurrentDist = event.value;
      this.CustFilter.Value = this.CurrentDist;
      this.LoadOrders();
    }
  }

  FollowOrder(follow: boolean, orderDetailRowPointer: string) {
    this.http.PostUserActivity(this.CurUser.UserId.toString(), "Order Status", "Follow Order", orderDetailRowPointer, this.CurUser.IsTolomaticUser ? this.CurrentDist : this.CurUser.DistributorId);
    this.http.FollowOrderDetail(follow, orderDetailRowPointer, this.CurUser.UserId.toString());
  }

  OrderSort_Change(event: any) {
    this.OrderSortValue = event.value;
    this.LoadOrders();
  }

  PageEvent(event: any) {
    this.PageIndex = event.pageIndex;
    this.PageSize = event.pageSize;
    this.LoadOrders();
  }

  SubscribeToUpdates(orderNumber: string) {

  }

  ViewDetails(order: OrderHistory, detail: OrderDetail) {
    var dialogConfig = this.GetDialogConfig("NewForce");

    var orderObject = { type: "OrderDetail", order:order, detail: detail};
    dialogConfig.data = orderObject;
    
    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CurrentOpenDialog.close();
    });
  }

  SubmitFilters() {
    //this.matFilterMenu.close.emit();
    this.PageIndex = 0;
    this.LoadOrders();
  }
  

  GetDialogConfig(name: string): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = name;
    dialogConfig.height = "80%";
    dialogConfig.width = "80%";

    return dialogConfig;
  }


  SetStartDateFilterValue(event: any) {
    this.OrderDateMin_Filter.Value = event.value;
  }

  SetEndDateFilterValue(event: any) {
    this.OrderDateMax_Filter.Value = event.value;

  }

}
